export const environment = {
  apiUrl: 'https://api.staging.listofin.com/itc',
  production: false,
  zipCodeApiUrl: 'https://api.listofin.com/store-service',
  expandedRaterUrl: 'https://pos.legacy.staging.listofin.com',
  cookieDomain: 'listofin.com',
};
